import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import Axios from 'axios';
import { isCacheValid, getCacheKey } from '../cacheUtils';

export const fetchAlerts = createAsyncThunk(
  'alerts/fetchAlerts',
  async (filters = {}, { getState, rejectWithValue }) => {
    const state = getState().alerts;
    const cacheKey = getCacheKey(filters);

    if (isCacheValid(state.lastFetched[cacheKey])) {
      return { data: state.data[cacheKey], cacheKey, cached: true };
    }

    try {
      const params = new URLSearchParams();
      if (filters.type) params.append('type', filters.type);
      if (filters.severity) params.append('severity', filters.severity);
      if (filters.page) params.append('page', filters.page);
      if (filters.limit) params.append('limit', filters.limit);

      const queryString = params.toString();
      const url = `/api/dashboard/alerts${queryString ? `?${queryString}` : ''}`;
      const response = await Axios.get(url);
      return { data: response.data.data, cacheKey, cached: false };
    } catch (err) {
      return rejectWithValue(err.response?.data?.message || 'Failed to fetch alerts');
    }
  }
);

const alertsSlice = createSlice({
  name: 'alerts',
  initialState: {
    data: {},
    loading: false,
    error: null,
    lastFetched: {},
  },
  reducers: {
    invalidateCache: (state) => {
      state.lastFetched = {};
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchAlerts.pending, (state, action) => {
        const cacheKey = getCacheKey(action.meta.arg);
        if (!state.data[cacheKey]) {
          state.loading = true;
        }
      })
      .addCase(fetchAlerts.fulfilled, (state, action) => {
        const { data, cacheKey, cached } = action.payload;
        if (!cached) {
          state.data[cacheKey] = data;
          state.lastFetched[cacheKey] = Date.now();
        }
        state.loading = false;
        state.error = null;
      })
      .addCase(fetchAlerts.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { invalidateCache: invalidateAlertsCache } = alertsSlice.actions;
export default alertsSlice.reducer;